'use strict';

/**
 * replace html entities
 *
 * @param   {String} str
 * @returns {String}
 */
var escape, flatten, flattenDeep, isEmpty, isObject, omit, pick, pickByIdentity, unescape, uniq, uniqIteratee, uniqueId,
  slice = [].slice;

escape = function(str) {
  var characters, encodeEntityMap;
  encodeEntityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };
  characters = new RegExp('[' + Object.keys(encodeEntityMap) + ']', 'g');
  return str.replace(characters, function(s) {
    return encodeEntityMap[s];
  });
};

unescape = function(str) {
  var characters, decodeEntityMap;
  decodeEntityMap = {
    '&amp;': '&',
    '&#38;': '&',
    '&#x26;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#34;': '"',
    '&#x22;': '"',
    '&#39;': "'",
    '&#x27;': "'",
    '&#96;': '`',
    '&#x60;': '`'
  };
  characters = new RegExp('(' + Object.keys(decodeEntityMap).join('|') + ')', 'g');
  return str.replace(characters, function(s) {
    return decodeEntityMap[s];
  });
};


/**
 * Flatten array
 *
 * @param   {Array}   arr     - Array to be deep flattened
 * @param   {Boolean} shallow - Flatten only shallow
 * @returns {Array}
 */

flatten = function(arr, shallow) {
  var ref;
  if (shallow == null) {
    shallow = false;
  }
  if (shallow) {
    return (ref = []).concat.apply(ref, arr);
  }
  return flattenDeep(arr);
};


/**
 * Deep flattening array
 *
 * @param   {Array} arr
 * @param   {Array} [res]
 * @returns {Array} res
 * @recursive
 */

flattenDeep = function(arr, res) {
  if (res == null) {
    res = [];
  }
  arr.forEach(function(value) {
    if (Array.isArray(value)) {
      return flattenDeep(value, res);
    } else {
      return res.push(value);
    }
  });
  return res;
};


/**
 * Determine if iteratee is empty
 *
 * @param   {*}       iteratee
 * @returns {Boolean}
 */

isEmpty = function(iteratee) {
  if (Array.isArray(iteratee)) {
    return !iteratee.length;
  }
  if (isObject(iteratee)) {
    return !Object.keys(iteratee).length;
  }
};


/**
 * Determine if iteratee is an Object
 *
 * @param   {*}       obj
 * @returns {Boolean}
 */

isObject = function(obj) {
  return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
};


/**
 * Delete key/value pairs from object
 *
 * @param   {Object}       obj
 * @param   {String|Array} [keys] - Key list (Optional)
 * @returns {Object}
 */

omit = function() {
  var keys, obj;
  obj = arguments[0], keys = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  if (!keys.length) {
    return obj;
  }
  keys = flattenDeep(keys);
  keys.forEach(function(key) {
    if (obj.hasOwnProperty(key)) {
      return delete obj[key];
    }
  });
  return obj;
};


/**
 * Pick key/value pairs from object
 *
 * @param   {Object}       obj
 * @param   {String|Array} [keys] - Key list (Optional)
 * @returns {Object}
 */

pick = function() {
  var keys, obj;
  obj = arguments[0], keys = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  if (!keys.length) {
    return {};
  }
  keys = flattenDeep(keys);
  return keys.reduce(function(collection, key) {
    if (obj.hasOwnProperty(key)) {
      collection[key] = obj[key];
    }
    return collection;
  }, {});
};


/**
 * Remove falsey key/value pairs from object
 *
 * @param   {Object} obj
 * @returns {Object}
 */

pickByIdentity = function(obj) {
  Object.keys(obj).forEach(function(key) {
    if (!obj[key]) {
      return delete obj[key];
    }
  });
  return obj;
};


/**
 * Produces a duplicate-free version of the array
 *
 * @param   {Array}    arr
 * @param   {*}                   - (Placeholder)
 * @param   {Function} [iteratee] - Transformation function
 * @returns {Array}
 */

uniq = function() {
  var arr, iteratee;
  arr = arguments[0], iteratee = arguments[arguments.length - 1];
  if (!Array.isArray(arr)) {
    arr = [arr];
  }
  if (typeof iteratee === 'function') {
    arr = arr.map(iteratee);
  }
  return Array.from(new Set(arr));
};


/**
 * Produces unique increasing numbers
 *
 * @param   {String}        [prefix] - Prefix to be set before the ID (Optional)
 * @returns {String|Number}
 */

uniqIteratee = 0;

uniqueId = function(prefix) {
  var i;
  if (prefix == null) {
    prefix = '';
  }
  i = uniqIteratee++;
  return prefix + i;
};

module.exports = {
  escape: escape,
  flatten: flatten,
  isEmpty: isEmpty,
  isObject: isObject,
  omit: omit,
  pick: pick,
  pickByIdentity: pickByIdentity,
  uniq: uniq,
  unescape: unescape,
  uniqueId: uniqueId
};

